module.exports = __webpack_public_path__ + "static/media/ligou.7c51857e.jpg";